import { render, staticRenderFns } from "./SettingsToolbar.vue?vue&type=template&id=6ec1f18b"
import script from "./SettingsToolbar.vue?vue&type=script&lang=js"
export * from "./SettingsToolbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports